import cleave from '../directives/cleave'

const GlobalDirectives = {
  install(Vue) {
    Vue.directive('cleave', cleave)
  }
}

export default GlobalDirectives
